import React, { ReactElement } from 'react'
import MySelect from '../formGroup/MySelect'
import TextInput from '../formGroup/TextInput'
import { PatrimonyTypes } from './Options'
import { IPatrimonyProps } from '../../interfaces/Step3'

const PatrimonyCard = ({
  register,
  errors,
  index,
  patrimony_type,
  handleChange,
  triggerValidation,
}: IPatrimonyProps): ReactElement => {
  const error =
    errors &&
    errors.patrimony_types &&
    errors.patrimony_types[patrimony_type.key]
      ? errors.patrimony_types[patrimony_type.key]
      : {
          patrimoine_type: null,
          patrimoine_montant: null,
        }

  return (
    <div className="row pb3">
      <MySelect
        className="colMd6 mb15 mb0md"
        options={PatrimonyTypes}
        value={patrimony_type.patrimoine_type}
        register={register({ required: true })}
        name={`patrimony_types[${patrimony_type.key}][patrimoine_type]`}
        id={`patrimoine_type${patrimony_type.key}`}
        error={error.patrimoine_type}
        label="Type de patrimoine"
        required
        onChange={(e) =>
          handleChange(index, {
            patrimoine_type: e.target.value,
            patrimoine_montant: patrimony_type.patrimoine_montant,
            key: patrimony_type.key,
          })
        }
      />
      <TextInput
        register={register({
          required: true,
          validate: {
            onlyDigits: (value) =>
              !value.match('[^0-9]') ||
              'Veuillez fournir seulement des chiffres.',
            max: (value) =>
              !(value > 99999999999) ||
              'Le montant renseigné dépasse la limite autorisée',
          },
        })}
        error={error.patrimoine_montant}
        name={`patrimony_types[${patrimony_type.key}][patrimoine_montant]`}
        id={`patrimoine_montants${patrimony_type.key}`}
        defaultValue={patrimony_type.patrimoine_montant}
        label="Montant estimé (en €)"
        required
        className="colMd6"
        placeHolder="Votre texte ici..."
        inputClassName="inputFieldSecondary"
        onChange={(e) =>
          handleChange(index, {
            patrimoine_type: patrimony_type.patrimoine_type,
            patrimoine_montant: e.target.value,
            key: patrimony_type.key,
          })
        }
        triggerValidation={triggerValidation}
      />
    </div>
  )
}

export default PatrimonyCard
